(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["petpro-card-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('petpro-card-purchase')) {
  customElements.define('petpro-card-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.onVariantChange) return;
      this.onVariantChange = event => {
        if (event.target.matches('.pp-card-variant__select')) this.updateVariant(event.target);
      };
      this.addEventListener('change', this.onVariantChange);
    }
    updateVariant(select) {
      const option = select.selectedOptions[0];
      const card = this.closest('.product-card');
      if (!option || !card) return;
      const price = this.querySelector('[data-pp-card-price]');
      const template = Array.from(this.querySelectorAll('template[data-pp-variant-price]')).find(node => node.dataset.ppVariantPrice === select.value);
      if (price && template) price.replaceChildren(template.content.cloneNode(true));
      const image = card.querySelector('.product-card__image img');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
        image.alt = option.dataset.imageAlt || '';
      }
      card.querySelectorAll('a.product-card__image, a.product-card__heading').forEach(link => {
        const url = new URL(link.href, document.baseURI);
        url.searchParams.set('variant', select.value);
        link.href = url.href;
      });
      const quantity = this.querySelector('[name="quantity"]');
      if (quantity) quantity.value = option.dataset.quantity || '1';
      const form = this.querySelector('product-form');
      if (typeof form?.handleErrorMessage === 'function') form.handleErrorMessage();
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onVariantChange);
      this.onVariantChange = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["petpro-compact-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('petpro-care-carousel')) {
  customElements.define('petpro-care-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.resizeObserver) return;
      this.track = this.querySelector('.pp-care-track');
      this.controls = this.querySelector('.pp-care-controls');
      if (!this.track || !this.controls) return;
      this.previous = this.controls.querySelector('[data-care-prev]');
      this.next = this.controls.querySelector('[data-care-next]');
      this.update = () => {
        this.controls.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      };
      const move = direction => this.track.scrollBy({left: direction * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      this.previous.onclick = () => move(-1);
      this.next.onclick = () => move(1);
      this.track.addEventListener('scroll', this.update, {passive: true});
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.track?.removeEventListener('scroll', this.update);
      this.resizeObserver = null;
    }
  });
}
if (!window.petproCareVariants) {
  window.petproCareVariants = true;
  document.addEventListener('change', event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.classList.contains('pp-care-variant__select')) return;
    const option = select.selectedOptions[0];
    const card = select.closest('.pp-care-card');
    if (!option || !card) return;
    const amount = card.querySelector('[data-pp-amount]');
    if (amount && option.dataset.price) amount.textContent = option.dataset.price;
    const compare = card.querySelector('[data-pp-compare]');
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    card.querySelector('[data-pp-price]')?.classList.toggle('pp-care-price--sale', Boolean(option.dataset.compare));
    const sale = card.querySelector('[data-pp-sale]');
    if (sale) {
      sale.textContent = option.dataset.discount || '';
      sale.hidden = !option.dataset.discount;
    }
    const shipping = card.querySelector('[data-pp-shipping]');
    if (shipping) shipping.hidden = option.dataset.freeShipping !== '1';
    const link = card.querySelector('.pp-care-link');
    if (link) {
      const url = new URL(link.getAttribute('href'), location.origin);
      url.searchParams.set('variant', option.value);
      link.setAttribute('href', url.pathname + url.search + url.hash);
    }
    card.querySelector('.product-form__error-message-wrapper')?.setAttribute('hidden', '');
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["petpro-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.petproDialogs) return;
  window.petproDialogs = true;
  if (typeof HTMLDialogElement !== 'function' || typeof HTMLDialogElement.prototype.showModal !== 'function') return;

  const root = document.documentElement;
  let swallowEscape = false;

  const isPetproDialog = element => element instanceof HTMLDialogElement && element.classList.contains('pp-dialog');

  const findDialog = opener => {
    const id = opener.getAttribute('aria-controls');
    if (!id) return null;
    const scope = opener.closest('[data-pp-dialog-scope]');
    const scoped = scope && scope.querySelector(`#${CSS.escape(id)}`);
    return scoped || document.getElementById(id);
  };

  const open = dialog => {
    if (dialog.open) return;
    dialog.querySelectorAll('[data-pp-dialog-external] a[href]').forEach(link => {
      const href = link.getAttribute('href') || '';
      if (href.startsWith('#') || link.hasAttribute('target')) return;
      link.target = '_blank';
      link.rel = 'noopener';
    });
    root.classList.add('pp-dialog-lock');
    dialog.showModal();
    const body = dialog.querySelector('.pp-dialog__body');
    if (body) body.scrollTop = 0;
  };

  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const opener = target.closest('[data-pp-dialog-open]');
    if (opener) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const dialog = findDialog(opener);
      if (!isPetproDialog(dialog)) return;
      event.preventDefault();
      open(dialog);
      return;
    }

    const closer = target.closest('[data-pp-dialog-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog && dialog.open) dialog.close();
      return;
    }

    if (isPetproDialog(target) && target.open) {
      const rect = target.getBoundingClientRect();
      const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) target.close();
    }
  });

  document.addEventListener('close', event => {
    if (!isPetproDialog(event.target)) return;
    if (!document.querySelector('dialog.pp-dialog[open]')) root.classList.remove('pp-dialog-lock');
  }, true);

  // Escape cierra solo el popup, no una ventana del tema que lo contenga (por ejemplo, la vista rápida).
  const swallowNextEscapeKeyup = () => {
    swallowEscape = true;
    setTimeout(() => { swallowEscape = false; }, 500);
  };
  document.addEventListener('cancel', event => {
    if (isPetproDialog(event.target)) swallowNextEscapeKeyup();
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    const dialogs = document.querySelectorAll('dialog.pp-dialog[open]');
    const dialog = dialogs[dialogs.length - 1];
    if (!dialog) return;
    event.preventDefault();
    swallowNextEscapeKeyup();
    dialog.close();
  }, true);
  document.addEventListener('keyup', event => {
    if (!swallowEscape || event.key !== 'Escape') return;
    swallowEscape = false;
    event.stopPropagation();
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["petpro-free-shipping"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.petproFreeShipping) return;
  window.petproFreeShipping = true;
  const OLD = '.badge__container > .badge--free_shipping:not(.pp-fs-badge):not(.pp-fs-plain)';

  // La plantilla del producto más cercana: la de su sección en la ficha o en la vista rápida.
  const findTemplate = node => {
    for (let element = node.parentElement; element; element = element.parentElement) {
      const template = element.querySelector('template[data-pp-fs-product]');
      if (template) return template;
    }
    return null;
  };

  // Presentación elegida: la del formulario de compra de la sección; si no, la de la dirección.
  const currentVariant = container => {
    const sectionId = (container.getAttribute('id') || '').replace('badge__container-', '');
    const form = sectionId && document.getElementById(`product-form-${sectionId}`);
    const input = form && form.querySelector('[name="id"]');
    if (input && input.value) return input.value;
    return new URLSearchParams(window.location.search).get('variant');
  };

  const sync = () => {
    document.querySelectorAll(OLD).forEach(old => {
      const template = findTemplate(old);
      const badge = template && template.content.firstElementChild;
      if (!badge) {
        old.classList.add('pp-fs-plain');
        return;
      }
      const variants = template.getAttribute('data-pp-fs-variants');
      if (variants !== null) {
        const id = currentVariant(old.parentElement);
        if (!id || !variants.includes(`,${id},`)) {
          old.remove();
          return;
        }
      }
      old.replaceWith(badge.cloneNode(true));
    });
  };

  const init = () => {
    sync();
    if (window.MutationObserver) new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["petpro-menu-directory"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest('.pp-menu-brand-sections__link');
  if (!link) return;
  const destination = new URL(link.href, window.location.href);
  if (!destination.hash || destination.origin !== window.location.origin || destination.pathname !== window.location.pathname) return;
  const drawer = link.closest('header-drawer');
  const closeButton = drawer?.querySelector('.menu-drawer__close-button.close-menu-js');
  closeButton?.click();
});

(() => {
  let pendingFrame = 0;
  const boundDirectories = new WeakSet();

  const fitDirectory = (directory) => {
    const list = directory.querySelector('.pp-menu-directory__list');
    if (!list || !list.getBoundingClientRect().width) return;

    const mobileSubmenu = directory.closest('.pp-menu-brands-submenu');
    const mobileInner = mobileSubmenu?.querySelector('.menu-drawer__inner-submenu');
    const desktopFrame = directory.closest('.pp-megamenu-frame');
    const viewport = window.visualViewport;
    const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
    let availableBottom = viewportBottom - 16;

    directory.setAttribute('data-pp-brand-fit', '');
    if (mobileInner) {
      const content = directory.closest('.menu-drawer__submenu-content');
      const bottomPadding = content ? parseFloat(getComputedStyle(content).paddingBottom) || 0 : 0;
      availableBottom = Math.min(availableBottom, mobileInner.getBoundingClientRect().bottom - bottomPadding - 8);
      mobileInner.scrollTop = 0;
    } else if (desktopFrame) {
      availableBottom -= parseFloat(getComputedStyle(desktopFrame).paddingBottom) || 0;
    }

    const items = Array.from(list.children);
    items.forEach((item) => { item.hidden = false; });
    let visibleCount = items.length;
    while (visibleCount && list.getBoundingClientRect().bottom > availableBottom) {
      items[--visibleCount].hidden = true;
    }
    mobileSubmenu?.setAttribute('data-pp-brand-fit', '');
  };

  const scheduleFit = () => {
    if (pendingFrame) return;
    pendingFrame = requestAnimationFrame(() => {
      pendingFrame = 0;
      document.querySelectorAll('.pp-menu-directory--marcas').forEach((directory) => {
        if (!boundDirectories.has(directory)) {
          boundDirectories.add(directory);
          directory.closest('.submenu-container')?.addEventListener('mouseenter', scheduleFit);
        }
        fitDirectory(directory);
      });
    });
  };

  document.addEventListener('toggle', scheduleFit, true);
  document.addEventListener('focusin', scheduleFit);
  document.addEventListener('shopify:section:load', scheduleFit);
  window.addEventListener('resize', scheduleFit);
  window.addEventListener('scroll', scheduleFit, { passive: true });
  window.addEventListener('orientationchange', scheduleFit);
  window.visualViewport?.addEventListener('resize', scheduleFit);
  window.visualViewport?.addEventListener('scroll', scheduleFit);
  document.fonts?.ready.then(scheduleFit);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFit, { once: true });
  } else {
    scheduleFit();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["petpro-product-structure-style"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.petproVariantLabels) return;
  window.petproVariantLabels = true;
  // Une el número con su unidad («100 g», «7.5 kg») y los signos entre números («12 × 100 g», «15 + 3») con
  // espacios no separables, para que el botón de la presentación no los parta en dos líneas.
  const UNIT = /(\d)\s+(?=(?:kg|g|mg|ml|l|cm|mm|oz|lb|un|und|unid|unidad|unidades|sobres?|latas?|pipetas?|tabletas?|comprimidos?|cápsulas?|dosis|ampollas?|frascos?)(?![\p{L}\d]))/giu;
  const SIGN = /(\d)\s+([×x+])\s+(?=\d)/g;
  const NBSP = String.fromCharCode(160);
  const fix = () => {
    document.querySelectorAll('.product-form__item label > span').forEach(span => {
      const text = span.textContent;
      const fixed = text.replace(UNIT, '$1' + NBSP).replace(SIGN, '$1' + NBSP + '$2' + NBSP);
      if (fixed !== text) span.textContent = fixed;
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; fix(); });
  };
  const init = () => {
    fix();
    if (window.MutationObserver) new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["petpro-recurring-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('petpro-recurring-cart')) {
  let repeat = false;
  class PetproRecurringCart extends HTMLElement {
    connectedCallback() {
      this.hidden = false;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', () => {
        repeat = this.querySelector('[value=repeat]').checked;
        document.querySelectorAll('petpro-recurring-cart').forEach(element => element.sync());
      }, options);
      this.querySelector('[data-review]').addEventListener('click', () => this.review(), options);
      this.sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
    sync() {
      this.querySelector('[value=repeat]').checked = repeat;
      this.querySelector('[value=once]').checked = !repeat;
      this.querySelector('[data-options]').hidden = !repeat;
      this.querySelector('[data-status]').textContent = '';
      this.parentElement.toggleAttribute('data-petpro-repeat', repeat);
    }
    async review() {
      const status = this.querySelector('[data-status]');
      const button = this.querySelector('[data-review]');
      button.disabled = true;
      status.textContent = '';
      try {
        const root = this.dataset.root.replace(/\/$/, '');
        const response = await fetch(`${root}/cart.js`, { credentials:'same-origin', cache:'no-store', signal:AbortSignal.timeout(10000) });
        if (!response.ok) throw new Error('cart_unavailable');
        const cart = await response.json();
        if (!cart.items?.length) throw new Error('cart_empty');
        location.assign('/apps/petpro-recurring?new=1');
      } catch {
        status.textContent = status.dataset.error;
      } finally { button.disabled = false; }
    }
  }
  customElements.define('petpro-recurring-cart', PetproRecurringCart);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["petpro-shipping-exclusion"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.petproShippingExclusion) return;
  window.petproShippingExclusion = true;
  const sync = () => {
    document.querySelectorAll('[data-pp-excluded-badge]').forEach(badge => {
      const card = badge.closest('.product-card, .pp-care-card, .pp-complement');
      if (!card) return;
      const selector = card.querySelector('select[name="id"], input[name="id"]');
      const id = selector?.value || badge.dataset.ppExcludedInitial;
      const excluded = badge.dataset.ppExcludedVariants.includes(`,${id},`);
      if (badge.hidden === excluded) badge.hidden = !excluded;
    });
    document.querySelectorAll('[data-pp-fs-card-variants]').forEach(badge => {
      const card = badge.closest('.product-card');
      if (!card) return;
      const selector = card.querySelector('select[name="id"], input[name="id"]');
      const id = selector?.value || badge.dataset.ppFsInitial;
      const eligible = badge.dataset.ppFsCardVariants.includes(`,${id},`);
      if (badge.hidden === eligible) badge.hidden = !eligible;
    });
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; sync(); });
  };
  const init = () => {
    sync();
    document.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["petpro-shipping-free-exclusions"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.petproFreeShippingAnnouncement) return;
  window.petproFreeShippingAnnouncement = true;
  const dialogId = 'PetproShippingFreeExclusionsDialog';
  const attached = new WeakSet();
  const paused = new Set();
  const findSlider = opener => opener?.closest('announcement-bar');
  const dialogOpen = () => document.getElementById(dialogId)?.open;
  const pause = slider => {
    if (!slider || typeof slider.stop !== 'function') return;
    paused.add(slider);
    slider.stop();
  };
  const resume = slider => {
    if (!slider || dialogOpen() || slider.contains(document.activeElement)) return;
    paused.delete(slider);
    if (typeof slider.stop === 'function') slider.stop();
    if (typeof slider.start === 'function') slider.start();
  };
  const sync = () => {
    document.querySelectorAll('[data-pp-shipping-announcement]').forEach(opener => {
      const slider = findSlider(opener);
      if (!slider) return;
      const active = opener.classList.contains('announcement-bar-js') && opener.classList.contains('active');
      opener.tabIndex = active ? 0 : -1;
      opener.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (attached.has(slider)) return;
      attached.add(slider);
      slider.addEventListener('mouseleave', event => {
        if (!dialogOpen() && !slider.contains(document.activeElement)) return;
        event.stopImmediatePropagation();
        pause(slider);
      }, true);
    });
  };
  const init = () => {
    sync();
    document.addEventListener('focusin', event => {
      const opener = event.target.closest?.('[data-pp-shipping-announcement]');
      if (opener) pause(findSlider(opener));
    });
    document.addEventListener('focusout', event => {
      const opener = event.target.closest?.('[data-pp-shipping-announcement]');
      if (opener) requestAnimationFrame(() => resume(findSlider(opener)));
    });
    document.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const opener = event.target.closest?.('[data-pp-shipping-announcement]');
      if (opener) pause(findSlider(opener));
    });
    document.addEventListener('close', event => {
      if (event.target.id === dialogId) requestAnimationFrame(() => paused.forEach(resume));
    }, true);
    new MutationObserver(sync).observe(document.body, {attributes:true, attributeFilter:['class'], childList:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
